import Products from 'Products';
import { ColorInfoObjInt, ProductColor } from '@gate31/feature/ProductColors/ProductColor';
import { InsalesProduct } from '@gate31/feature/InsalesProduct/InsalesProduct';
import { faro } from '@gate31/faro/src';

class ProductColorDeskError extends Error {
    name = 'ProductColorDeskError'
}

export interface IProductColor {
    productListId: Array<string>;
    product: InsalesProduct;
    productColor: ProductColor;

    getListColorInfo: (arg: Array<string>) => Promise<undefined | ColorInfoObjInt[]>;
    renderColorList: () => void;
}

export class ProductColorDesk implements IProductColor {
    productListId: Array<string>;
    product: InsalesProduct;
    productColor: ProductColor;

    constructor({ idList, product }: { idList: Array<string>; product: InsalesProduct }) {
        this.productListId = idList;
        this.product = product;
        this.productColor = new ProductColor({ product: this.product });
    }

    async getListColorInfo(idList: Array<string>) {
        const availableIds = await fetch(`/front_api/products.json?ids=${idList.join(',')}`)
            .then(r => r.json())
            .then(r => {
                return r.products.map((p: { id: number }) => String(p.id));
            })
            .catch(() => {
                return [];
            });

        const products: InsalesProduct[] = await Products.getList(availableIds)
            .then(items => Object.values(items))
            // .then(items => items.filter(item => item.available))
            .then<InsalesProduct[]>(items => items.map(item => new InsalesProduct(item)))
            .fail(error => {
                faro.api.pushError(new ProductColorDeskError(error), {
                    context: {
                        section: `product colors - ${error}`
                    }
                });
            });

        if (! products) {
            return;
        }

        return this.productColor.transformColorObject(products);
    }

    async renderColorList(): Promise<string | undefined> {
        const colorInfoList = await this.getListColorInfo(this.productListId);

        if (! colorInfoList) {
            return;
        }

        return colorInfoList.map(colorInfo => {
            return `<a data-product-id="${colorInfo.id}" class="${this.product.id === colorInfo.id ? 'current' : ''}" data-color-name="${colorInfo.colorName}" href="${colorInfo.url}">
                <span style="background: ${colorInfo.background};"></span>
            </a>`;
        }).join('');
    }
}
